<template>
<div class="regionManagementContainer">
  <div class="mainContent" :style="styleObject">
    <div class="contentShowArea">
      <div class="contentArea">
        <div class="treeAside">
          <div class="treeTop">
            <span class="treeTopTitle">区域</span>
            <el-button v-show="!treeHandler" type="text" @click="treeHandler = !treeHandler" style="color:#2d8cf0;margin-left:170px;">维护</el-button>
            <!-- <el-button title="添加根组织" v-show="treeHandler&&rolePermit('org:add') /*&& isPermit('org:add') && isTenant()*/" type="text" size="small" icon="el-icon-plus" @click.stop="clickAddOrganize" style="color:#2d8cf0;"></el-button> -->
            <el-button class="complete" v-show="treeHandler" type="text" @click="treeHandler = !treeHandler" style="color:#ff9900;margin-left:170px;">完成</el-button>
          </div>
          <div class="treeBox">
            <el-tree
              lazy
              :load="loadData"
              :props="props"
              v-if="1"
              class="tree"
              ref="tree"
              :indent="6"
              node-key="value"
              highlight-current
              :expand-on-click-node="false"
              @node-click="handleNodeSelect">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
                  <span class="treeLabel" :style="{width : treeHandler ? '130px' : '190px'}">{{ showLabel(node.label) }}</span>
                </el-tooltip>
                <!-- node.label != '终端用户' 终端用户不让修改 -->
                <span v-show="treeHandler &&(data.terminalFlag != 1)" class="treeBtn">
                  <el-button v-if="isShow(data)" type="text" size="small" icon="el-icon-plus" @click.stop="clickAddOrganize(data)" style="color:#2d8cf0;"></el-button>
                  <el-button v-if="isShow(data)" type="text" size="small" icon="el-icon-edit" @click.stop="clickEditOrganize(data, node)" style="color:#2d8cf0;"></el-button>
                  <el-button v-if="isShow(data)" type="text" size="small" icon="el-icon-close" @click.stop="clickRemoveOrganize(node, data)" style="color:#ed4014;"></el-button>
                </span>
              </span>
            </el-tree>
            <!-- <el-tree v-if="1" class="tree" ref="tree" :indent=6 :data="treeData" how-checkbox node-key="value" default-expand-all highlight-current :expand-on-click-node="false" @node-click="handleNodeSelect">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
                  <span class="treeLabel" :style="{width : treeHandler ? '130px' : '190px'}">{{ showLabel(node.label) }}</span>
                </el-tooltip>
                node.label != '终端用户' 终端用户不让修改
                <span v-show="treeHandler &&(data.terminalFlag != 1)" class="treeBtn">
                  <el-button v-if="true" type="text" size="small" icon="el-icon-plus" @click.stop="clickAddOrganize(data)" style="color:#2d8cf0;"></el-button>
                  <el-button v-if="true" type="text" size="small" icon="el-icon-edit" @click.stop="clickEditOrganize(data)" style="color:#2d8cf0;"></el-button>
                  <el-button v-if="true" type="text" size="small" icon="el-icon-close" @click.stop="clickRemoveOrganize(node, data)" style="color:#ed4014;"></el-button>
                </span>
              </span>
            </el-tree> -->
          </div>
        </div>
        <div class="management">
          <div class="userManagement">
            <div class="title">用户列表</div>
            <div class="umHandler">
              <div class="umHandlerLeft">
                <el-input placeholder="请输入昵称/电话" v-model="queryForm.key" style="width:200px;"></el-input>
                <el-select v-model="queryForm.userType" clearable placeholder="人员类型">
                  <el-option label="负责人" value="0"></el-option>
                  <el-option label="安装人" value="1"></el-option>
                </el-select>
                <button class="primaryBtn" @click="searchAlco">搜索</button>
                <el-button class="primaryBtn" :style="{background:treeFlag==1?'#ccc':'#2177E6',cursor:treeFlag==1?'not-allowed':'pointer'}" :disabled="treeFlag == 1" @click="showAddForm">绑定区域与用户关系</el-button>
              </div>
            </div>
            <div class="umTableBox">
              <div class="tableBox">
                <border-table class="dataTable" :loading="rolesLoading" :tableData="actionQueryData" :pageSizes="[10, 20, 50]" :pages="pagination" @currentChange="handleCurrentChange" @sizeChange="handleSizeChange">
                  <el-table-column prop="id" label="ID" width="70" sortable></el-table-column>
                  <el-table-column prop="nickName" label="昵称" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="regionName" label="区域名称" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="tel" label="联系方式" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="isEnabled" label="是否启用">
                    <template slot-scope="scope">
                      <span v-if="scope.row.isEnabled" style="color:#28C6A2">启用</span>
                      <span v-else style="color:#DD3071">禁用</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="userType" label="人员类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.userType == 0 ? "负责人" : "安装人"}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="updateTime" label="更新时间" show-overflow-tooltip></el-table-column>
                  <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                      <el-button :style="{color:(scope.row.terminalFlag == 1?'#ccc':'#DD3071')}" :disabled="scope.row.terminalFlag == 1" v-if="true" class="delBtn" type="text" icon="el-icon-delete" @click="del(scope.row.regionId,scope.row.userId,scope.row.userType)">解除区域关系</el-button>
                    </template>
                  </el-table-column>
                </border-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-drawer class="regionManagementDD" title="区域维护" size="450px" :modal="false" :visible.sync="addModel" @close="closeAddModel" :wrapperClosable="false" direction="rtl" ref="drawer">
      <div class="drawerWrap">
        <div class="drawerBody">
          <el-form :model="addForm" ref="addForm" :rules="orgRules" class="formBox" label-position="right" label-width="120px">
            <el-form-item label="区域名称" prop="name">
              <el-input maxlength="100" placeholder="请输入区域名称" v-model="addForm.name"></el-input>
            </el-form-item>
            <el-form-item label="序号" prop="">
              <el-input-number v-model="addForm.serial" :min="1" :max="100" label="序号"></el-input-number>
            </el-form-item>
            <!-- <el-form-item label="是否为社区" prop="isCommunity">
              <el-radio-group v-model="addForm.isCommunity">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item> -->
          </el-form>
        </div>
        <div class="drawerFoot">
          <el-button type="primary" @click="addOrUpdateOperation">{{isAddOperation ? "添加" : "编辑"}}</el-button>
          <el-button v-show="isAddOperation" @click="resetValue('addForm')">重置</el-button>
          <el-button @click="cancelTreeModel('addForm')">取 消</el-button>
        </div>
      </div>
    </el-drawer>
    <el-drawer :title="addOrEditPar.title" :modal="false" :visible.sync="addOrEditPar.show" :size="drawerWidth" @close="closeMess" :wrapperClosable="false" direction="rtl" ref="addOrEditPar">
      <add-or-edit v-if="addOrEditPar.show" :addOrEditPar="addOrEditPar" :btnLoading="btnLoading" @formCancel="formCancel" @changeWidth="changeWidth" @formSubmit="formSubmit"></add-or-edit>
    </el-drawer>
  </div>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable";
import AddOrEdit from "@/components/regionalManagement/AddOrEdit"
const defaultTreeForm = {
  name: "",
  serial: 50,
  isCommunity: false
};
export default {
  components: {
    BorderTable,
    AddOrEdit
  },
  computed: {
    isShow () {
      return data => {
        // console.log(1, data.id == 0)
        // console.log(2, !this.storage.getSession("tenant"))
        return !(!this.storage.getSession("tenant") && data.id == 0)
      }
    }
  },
  data() {
    return {
      btnLoading: false,
      // 添加编辑====
      addOrEditPar: {
        title: "",
        show: false,
        row: {},
        type: ''
      },
      drawerWidth: "750px",
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      rolesLoading: false,
      addUserRole: false,
      editUserRole: false,
      noData: false,
      tableMaxHeight: 0,
      orgExpandedKeys: [],
      treeData: [],
      currentTreeId: '',
      treeHandler: false,
      addModel: false,
      isAddOperation: true,
      addForm: defaultTreeForm,
      orgRules: {
        name: [{
            required: true,
            message: "请输入区域名称",
            trigger: "blur"
          },
          // {
          //   pattern: /^[0-9a-zA-Z\u4E00-\u9FA5\(\)]*$/gi,
          //   message: "区域名称格式为中文、字母、数字组成",
          //   trigger: "blur"
          // },
          {
            min: 1,
            max: 100,
            message: "区域名称长度在 1 到 100 个字符",
            trigger: "change"
          }
        ],
        serial: [{
          required: true,
          message: "请输入序号",
          trigger: "blur"
        }]
      },
      queryForm: {
        regionId: this.currentTreeId,
        userId: "",
        order: "desc",
        sort: "createTime",
        key: '',
        userType: ''
      },
      roles: [],
      tableMaxHeight: 0,
      actionQueryData: [],
      styleObject: {
        height: ""
      },
      treeFlag: '',
      props: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      },
      setCurrentNode: null
    }
  },
  created() {
    this.makeheight()
    // this.query();
    // this.queryRole();
    // this.searchAlco();
    if (this.getViewportSize.height > 768) {
      this.tableMaxHeight = this.getViewportSize.height - 376;
    } else {
      this.tableMaxHeight = 400;
    }
  },
  methods: {
    change(data) {
      console.log(data)
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      _this.tableHeight = window.innerHeight - 340;
      // console.log(_this.tableHeight);
      window.onresize = () => {
        return (() => {
          _this.tableHeight = window.innerHeight - 340;
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    isTenant() {
      let orgId = sessionStorage.getItem("orgId");
      return "0" === orgId;
    },
    showLabel(label) {
      if (!label) {
        return label;
      }
      return label;
    },
    // 查询组织
    queryTreeNode(pid = 0) {
      this.storage.setSession('currentTreeId', '');
      this.storage.setSession('currentTreeLabel', '');
      this.request.get(`/front/device/region/findTreeById?id=${pid}`)
        .then(rs => {
          this.treeData = rs.code === 200 ? rs.data : [];
          this.currentTreeId = this.treeData.length > 0 ? this.treeData[0].value : '';
          //设置选中
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].value)
          })
          this.queryAlcoInfo(1, this.pagination.pageSize);
        })
        .catch(error => (this.treeData = []));
    },
    // 查询区域
    loadData (node, resolve) {
      this.node = node
      this.resolve = resolve
      if (node.level === 0) {
        this.storage.setSession('currentTreeId', '')
        this.storage.setSession('currentTreeLabel', '')

        let root = { id: 0, label: '区域机构', parentId: 0, value: 0 }
        
        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(0)
          let nodedata = node.childNodes[0];
          nodedata.expanded = true;
          nodedata.loadData();
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/device/region/findTreefenjiById?id=${pid}`).then(rs => {
          let data = rs.code === 200 ? rs.data : []

          this.queryAlcoInfo(1, this.pagination.pageSize);
          resolve(data)
          
        }).catch(error => {
          console.error(error)
          resolve([])
        })        
      }
    },
    addTreeNode(isReload = true) {
      let form = this.addForm;
      let submitForm = {
        serial: form.serial,
        name: form.name,
        parentId: this.currentTreeId
      }
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          this.request.post("/front/device/region/add", submitForm)
            .then(rs => {
              if (rs.code === 200) {
                // 非租户且是在根区域添加区域！
                // if (!this.storage.getSession("tenant") && !this.currentTreeId) {
                //   this.$message({ type: 'warning', message: '请联系上级绑定区域与用户关系，否则不能正常操作！' })
                // } else {
                  this.$message({
                    type: "success",
                    message: `区域已添加!`
                  });
                // }
                // this.orgExpandKeys[0] = this.currentTreeId;
                // if (isReload) this.queryTreeNode();
                if (isReload) this.loadData(this.node, this.resolve)
                this.addModel = false;
              } else if (rs.code === 500) {
                this.$message({
                  type: "info",
                  message: `${rs.msg}`
                });
              }
            })
            .catch(error => {
              this.$message({
                type: "info",
                message: `操作失败!`
              });
            });
        } else {
          this.$message({
            type: "error",
            message: `表单验证失败!`
          });
        }
      })
    },
    editTreeNode(isReload = true) {
      let form = this.addForm;
      let submitForm = {
        id: form.id,
        serial: form.serial,
        name: form.name
      };

      this.$refs["addForm"].validate(valid => {
        if (valid) {
          this.request.post("/front/device/region/updateNameAndSerial", submitForm)
            .then(rs => {
              if (rs.code === 200) {
                this.$message({
                  type: "success",
                  message: `编辑成功!`
                });
                // this.orgExpandKeys[0] = this.currentTreeId;
                // if (isReload) this.queryTreeNode();
                if (isReload) this.loadData(this.node, this.resolve);
                this.addModel = false;
              } else if (rs.code === 500) {
                this.$message({
                  type: "info",
                  message: `${rs.msg}`
                });
              }
            })
            .catch(error => {
              this.$message({
                type: "info",
                message: `操作失败!`
              });
            });
        } else {
          this.$message({
            type: "error",
            message: `表单验证失败!`
          });
        }
      })

    },
    addOrUpdateOperation() {
      if (this.isAddOperation) {
        this.addTreeNode();
      } else {
        this.editTreeNode();
      }
    },
    closeAddModel() {
      this.addModel = false;
      // this.$refs["addForm"].resetFields();
    },
    // 移除区域
    removeTreeNode(data, isReload = true) {
      let id = data.value;
      let parentId = data.parentId;
      this.$confirm("此操作将永久删除该区域, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          this.request.delete(`/front/device/region/${id}`)
            .then(rs => {
              if (rs.code === 200) {
                this.$message({
                  type: "success",
                  message: `区域已删除!`
                });
                // if (isReload) this.queryTreeNode();
                if (isReload) this.loadData(this.node, this.resolve)
              } else if (rs.code === 500) {
                this.$message({
                  type: "info",
                  message: `${rs.msg}`
                });
              }
            })
            .catch(error => {
              return this.$message({
                type: "info",
                message: `删除失败!`
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      // console.log(item);
      this.treeFlag = item.terminalFlag
      this.currentTreeId = item ? (item.value ? item.value : '') : '';
      if(!this.treeFlag){
        this.storage.setSession('currentTreeId', this.currentTreeId);
        this.storage.setSession('currentTreeLabel', item.label);
      }
      this.queryAlcoInfo(1, this.pagination.pageSize);
    },
    // 添加区域
    clickAddOrganize(data) {
      // console.log(data);
      this.addForm = {
        name: "",
        serial: 50
      }
      this.isAddOperation = true;
      this.handleNodeSelect(data);
      this.resetValue('addForm');
      this.addModel = true;
    },
    // 编辑区域
    clickEditOrganize(data, node) {
      this.setCurrentNode = node
      this.isAddOperation = false;
      this.handleNodeSelect(data);
      this.addModel = true;
      this.addForm = {
        id: data.id,
        name: data.label,
        serial: data.serial
      }
    },
    clickRemoveOrganize(node, data) {
      this.removeTreeNode(data);
    },
    // 重置表单值
    resetValue(formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields();
      }
      this.resetFromValue();
    },
    resetFromValue() {
      this.addForm = defaultTreeForm;
    },
    cancelTreeModel(formName) {
      this.addModel = false;
      this.resetValue(formName);
    },
    del(id, userId, userType) {
      this.currentTreeId = ''
      this.$confirm("此操作将解除区域和用户关系, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          this.request.delete(`/front/device/region/${id}/${userId}/${userType}`).then(rs => {
            if (rs.code === 200) {
              this.msg.success("关系已解除!");
              this.queryAlcoInfo(1, this.pagination.pageSize);
            } else {
              this.msg.error("解除失败，" + rs.msg);
            }
          });
        })
        .catch(() => {
          this.msg.info("已取消");
        });
    },
    searchAlco() {
      this.pagination.currentPage = 1;
      this.queryAlcoInfo(this.pagination.currentPage, this.pagination.pageSize);
    },
    queryAlcoInfo(page, pageSize) {
      // console.log(this.storage.getSession('currentTreeId'));
      this.queryForm.regionId = this.currentTreeId ? this.currentTreeId : this.storage.getSession('currentTreeId');
      let params = Object.assign({}, this.queryForm, {
        page: page,
        pageSize: pageSize,
        sort: this.sort,
        order: this.order,
      });
      this.request.get("/front/device/region/query", params).then(rs => {
        // console.log(rs);

        if (rs.code === 200) {
          this.actionQueryData = rs.data ? rs.data : [];
          this.pagination.total = rs.total;
          this.noData = false;
          if (!rs.total) {
            this.noData = true;
          }
        } else {
          this.actionQueryData = [];
          this.noData = true;
        }
      });
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.queryAlcoInfo(1, this.pagination.pageSize);
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.queryAlcoInfo(this.pagination.currentPage, this.pagination.pageSize);
    },
    // 添加======
    showAddForm() {
      this.addOrEditPar.show = true
      this.addOrEditPar.type = 'edit'
      this.addOrEditPar.title = '绑定区域与用户关系'
      this.drawerWidth = "750px"
    },
    closeMess() {
      this.addOrEditPar.show = false;
    },
    changeWidth(width) {
      this.drawerWidth = width
    },
    formCancel(par) {
      this.addOrEditPar.show = par
    },
    async formSubmit(par) {
      this.currentTreeId = ''
      this.btnLoading = true
      if (this.addOrEditPar.type == 'edit') {
        const {
          code,
          msg
        } = await this.request.post('/front/device/region/update', par)
        if (code !== 200) {
          if (code == 500) {
            this.btnLoading = false
            return this.$message.error(msg)
          }
          return
        }
        this.queryAlcoInfo(1, this.pagination.pageSize);
        this.addOrEditPar.show = false
        this.drawerWidth = "750px"
        this.btnLoading = false
        return this.$message.success('绑定关系成功')
      }
    }
  },
  mounted: function () {
    // this.queryTreeNode();
  }
};
</script>

<style lang="scss">
.regionManagementContainer {
  height: 100%;

  .mainContent {
    margin: 12px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
    position: relative;
  }

  .contentShowArea {
    position: relative;
    height: 100%;

    .contentArea {
      width: 100%;
      height: 100%;
      background: #fff;
      padding: 20px;
      box-sizing: border-box;
      position: relative;
    }
  }

  .treeAside {
    position: absolute;
    width: 300px;
    height: 100%;
    padding: 20px;
    left: 0;
    top: 0;
    box-sizing: border-box;

    .treeTop {
      position: absolute;
      height: 40px;
      line-height: 40px;
      font-size: 0;
      font-weight: bold;
      top: 20px;
      z-index: 10;
      // left: 30px;
      padding-left: 10px;

      .treeTopTitle {
        // margin-right: 115px;
        // width: 750px;
        font-size: 18px;
        color: #333;
      }

      .el-button {
        margin-left: -24px;
      }

      .complete {
        margin-left: 10px;
      }
    }

    .treeBox {
      overflow: hidden;
      height: 100%;
      border: 1px solid #ebeef5;
      padding: 40px 0 10px;
      box-sizing: border-box;
    }

    .tree {
      height: 100%;
      overflow: auto;

      .el-tree-node__content {
        height: 40px;
      }

      .custom-tree-node {
        height: 40px;
        line-height: 40px;
        width: 100%;

        .treeLabel {
          font-size: 14px;
          display: inline-block;
          width: 130px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .treeBtn {
          float: right;

          .el-button {
            margin-left: 0;
          }
        }
      }
    }
  }

  .management {
    margin-left: 280px;
    height: 100%;

    // padding: 10px 0;
    &>div {
      border: 1px solid #ebeef5;
      padding: 10px 20px;
      box-sizing: border-box;

      .title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
      }
    }

    .userManagement {
      height: 100%;
      position: relative;

      .umHandler {
        overflow: hidden;
        line-height: 40px;
        margin: 10px 0;

        .umHandlerLeft {
          float: left;

          .el-input {
            vertical-align: middle;
            width: 200px;
            margin-right: 10px;

            .el-input__inner {
              line-height: 36px;
              height: 36px;
            }
          }
          .primaryBtn {
            background: #2177E6;
            color: #fff;
            padding: 0 15px;
            height: 36px;
            line-height: 36px;
            border: none;
            font-size: 14px;
            border-radius: 4px;
            outline: none;
            cursor: pointer;
            margin-right: 10px;
          }
        }

        .add {
          float: right;
          height: 32px;
          line-height: 32px;
          margin-top: 5px;
          padding: 0 12px;
        }
      }

      .umTableBox {
        margin-top: 20px;

        .tableBox {
          width: 100%;
          position: relative;
          min-height: 460px;

          .hasNoData {
            position: absolute;
            width: 360px;
            height: 392px;
            top: 55%;
            left: 50%;
            margin-top: -196px;
            margin-left: -180px;

            .noDataImg {
              width: 360px;
              height: 360px;

              img {
                width: 100%;
                height: 96%;
              }
            }

            p {
              text-align: center;
              margin-top: -10px;
              font-size: 24px;
              font-weight: bold;
              color: rgba(0, 73, 173, 1);
              line-height: 32px;
            }
          }
        }

        .dataTable {
          &::before {
            display: none;
          }

          .el-table__fixed-right {
            &::before {
              display: none;
            }

            .el-table__fixed-body-wrapper {
              tbody {
                tr {
                  td {
                    .cell {
                      text-align: center;

                      .editBtn {
                        color: #28c6a2;
                      }

                      .delBtn {
                        color: #dd3071;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.regionManagementDD {
  .formBox {
    .el-form-item {
      .content-panel {
        line-height: 40px;

        &>.el-checkbox {
          line-height: 50px;
        }
      }

      .privilege-form-item {
        padding: 0 10px;
      }
    }

    .el-input-number {
      width: 270px;
    }
  }

  .formBox1 {
    .el-input {
      width: 100%;
    }

    .vue-treeselect {
      margin-top: 5px;

      .vue-treeselect__control {
        div {
          line-height: 40px;
          height: 40px;
        }
      }
    }
  }

}

.drawerBody {
  .el-tag {
    margin-right: 10px;
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 180px !important;
    margin-right: 10px;
    vertical-align: bottom;
  }

  .plus-btn {
    padding: 8px;
    margin-left: 10px;
  }
}
</style>
